import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-grow-1" }
const _hoisted_2 = {
  key: 0,
  class: "opacity-50"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createBlock(_TransitionGroup, {
    tag: "div",
    class: "position-fixed bottom-0 end-0 pb-3 pe-3 d-flex flex-column align-items-end gap-2 z-4 pe-none",
    name: "toast"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (t) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["c-toast d-flex align-items-start gap-2", { 'text-bg-danger text-light': t.opts?.level === 'fail' }]),
          key: t.id
        }, [
          (t.opts?.level === 'fail')
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                name: "alert-circle"
              }))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(t.message.title), 1 /* TEXT */),
            (t.message.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(t.message.description), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          (t.opts?.closeable === true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "c-button-link",
                onClick: $event => (_ctx.remove(t.id))
              }, [
                _createVNode(_component_v_icon, { name: "x" })
              ], 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}